module.exports = __webpack_public_path__ + "img/com.adbglobal.whirlpool.87b0e930.webp";